export default "__VITE_ASSET__yj2YoWdx__"